<template>
  <div id="navigation-container">
    <div id="icon-wrapper">
      <button id="hamburger" v-if="lessThan599" @click="displayMenu = true">
        <font-awesome-icon :icon="['fas', 'bars']" />
      </button>
    </div>
    <div id="menu-wrapper" v-if="!lessThan599 || displayMenu">
      <div id="menu">
        <button
          id="close"
          v-if="lessThan599 && displayMenu"
          @click="displayMenu = false"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
        <ul>
          <li v-for="item in navItems" :key="item" :class="`menu-${item}`">
            <router-link
              :to="{ path: '/' + item }"
              @click="displayMenu = false"
              >{{ item.toUpperCase() }}
            </router-link>
          </li>
          <li class="menu-my-collection">
            <a :href="urls.portal + '/mycollection/index.php'" target="_blank">
              MY COLLECTION
            </a>
          </li>
        </ul>
        <!-- Temporary announcement, to be deleted -->
        <div id="database-announcement" v-if="dxaFull !== 'Partners'">
          <span>Tip:</span>
          The Database tool has been replaced with the Search bar in the header.
          Please enter your search term(s) into the bar to search the
          {{ dxaFull }} database.
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import media from "../mixins/media.js";
export default {
  name: "NavigationComponent",
  mixins: [media],
  data() {
    return {
      dxaFull: process.env.VUE_APP_DXA_FULL,
      lessThan599: window.matchMedia("(max-width: 599px)").matches,
      displayMenu: false,
      navItems: {
        about: "about",
        collection: "collection",
        partners: "partners",
        timeline: "timeline",
        credits: "credits",
      },
      urls: {
        portal: process.env.VUE_APP_PORTAL_URL,
        baroqueArt: process.env.VUE_APP_BAROQUE_ART_URL,
        islamicArt: process.env.VUE_APP_ISLAMIC_ART_URL,
        sharingHistory: process.env.VUE_APP_SHARING_HISTORY_URL,
        galleries: process.env.VUE_APP_GALLERIES_URL,
        images: process.env.VUE_APP_IMAGES_URL,
      },
      emails: {
        contactUs: process.env.VUE_APP_CONTACT_US_EMAIL,
      },
    };
  },
};
</script>



<style scoped lang="scss">
#navigation-container {
  position: sticky;
  top: 80px;
  width: 100%;
  z-index: 90;
}
#navigation-container ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  /* IE */
  display: -ms-grid;
  -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
/* IE */
.menu-about {
  -ms-grid-column: 1;
}
.menu-collection {
  -ms-grid-column: 2;
}
.menu-partners {
  -ms-grid-column: 3;
}
.menu-timeline {
  -ms-grid-column: 4;
}
.menu-credits {
  -ms-grid-column: 5;
}
.menu-my-collection {
  -ms-grid-column: 6;
}
#navigation-container li {
  @include flex-center;
  color: $light-text;
  line-height: 28px;
}
// Alternate menu item colors
li:nth-child(odd) {
  background-color: $theme-medium-dark;
}
li:nth-child(even) {
  background-color: $theme-light;
}
#navigation-container a {
  width: 100%;
  color: $light-text;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
}
#database-announcement {
  width: 100%;
  font-size: 90%;
  background-color: $theme-dark;
  text-align: center;
  color: $light-text;
  padding: 5px 15px;
}
#database-announcement span {
  font-weight: bold;
}

@media only screen and (max-width: 1199px) {
  #navigation-container li {
    font-size: 96%;
  }
}

@media only screen and (max-width: 974px) {
  #navigation-container ul {
    grid-template-columns: repeat(3, 1fr);
    /* IE */
    -ms-grid-columns: 1fr 1fr 1fr;
    -ms-grid-rows: 1fr 1fr;
  }
  /* IE */
  .menu-about {
    -ms-grid-column: 1;
    -ms-grid-row: 1;
  }
  .menu-collection {
    -ms-grid-column: 2;
    -ms-grid-row: 1;
  }
  .menu-partners {
    -ms-grid-column: 3;
    -ms-grid-row: 1;
  }
  .menu-timeline {
    -ms-grid-column: 1;
    -ms-grid-row: 2;
  }
  .menu-credits {
    -ms-grid-column: 2;
    -ms-grid-row: 2;
  }
  .menu-my-collection {
    -ms-grid-column: 3;
    -ms-grid-row: 2;
  }
}

@media only screen and (max-width: 599px) {
  #navigation-container {
    position: absolute;
    height: 0;
    z-index: 100;
  }
  #icon-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    height: 65px;
    width: 50px;
  }
  #hamburger {
    @include button-styles;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 40px;
    width: 40px;
    color: $light-text;
    font-size: 25px;
    margin-left: 10px;
  }
  #menu-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(black, 0.7);
  }
  #menu {
    @include flex-center;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    width: 50%;
    background-color: $theme-dark;
  }
  #close {
    @include button-styles;
    align-self: flex-end;
    color: $light-text;
    font-size: 24px;
    padding: 10px;
  }
  #navigation-container ul {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }
  #navigation-container ul li:first-child {
    border-top: 2px solid $theme-dark;
  }
  #navigation-container li {
    line-height: 35px;
    border-bottom: 2px solid $theme-dark;
  }
  #database-announcement {
    font-size: 90%;
    background-color: $theme-dark;
    text-align: left;
  }
}

@media only screen and (max-width: 499px) {
  #icon-wrapper {
    height: 75px;
    width: 42px;
  }
  #hamburger {
    height: 30px;
    width: 30px;
    font-size: 20px;
  }
}

@media only screen and (max-width: 399px) {
  #hamburger {
    margin-left: 8px;
  }
  #menu {
    width: 65%;
  }
  #close {
    font-size: 20px;
  }
}

@media print {
  #navigation-container {
    display: none;
  }
}
</style>